<template>
    <Button label="Upload Photos & Videos" class="btn-upload shrink-0" @click.prevent="onSelectFiles">
        <template #icon>
            <i class="icon mr-2">add_circle</i>
        </template>
    </Button>
</template>
<script setup>
import { useToast } from "primevue/usetoast";
import { computed, onMounted } from 'vue';

import Button from 'primevue/button';

import NProgress from 'nprogress'
import '../node_modules/nprogress/nprogress.css'

NProgress.configure({ showSpinner: false });

const config = useRuntimeConfig();
const myWidget = ref(null);
const colors = (config.public.THEME_COLORS || '#B3A37A,#6a5c36,#B3A37A').split(',');
onMounted(() => {
    myWidget.value = cloudinary.createUploadWidget(
        {
            cloudName: config.public.CLOUD_API_NAME,
            uploadPreset: config.public.CLOUD_API_PRESET,
            sources: ["local", "camera"],
            clientAllowedFormats: ['image', 'video'],
            showAdvancedOptions: false,
            cropping: false,
            multiple: true,
            maxFileSize: 10000000,
            maxImageFileSize: 10000000,
            maxVideoFileSize: 50000000,
            maxImageWidth: 4000,
            maxImageHeight: 4000,
            maxFiles: 10,
            autoMinimize: false,
            showCompletedButton: false,
            defaultSource: "local",
            thumbnailTransformation: "c_limit,h_500,w_500,fl_progressive:semi",
            styles: {
                palette: {
                    window: "#ffffff",
                    sourceBg: "#f4f4f5",
                    windowBorder: "#90a0b3",
                    tabIcon: "#000000",
                    inactiveTabIcon: "#555a5f",
                    menuIcons: "#555a5f",
                    link: colors[0],
                    action: colors[0],
                    inProgress: colors[0],
                    complete: colors[0],
                    error: "#cc0000",
                    textDark: "#000000",
                    textLight: "#fcfffd"
                },
                fonts: {
                    default: null,
                    "'Inter', sans-serif": {
                        url: "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700;900&family=Playfair+Display:wght@400;500;700&display=swap",
                        active: true
                    }
                }
            },
            // text: {} // https://upload-widget.cloudinary.com/2.8.3/global/text.json
        },
        (error, result) => {
            if (!error && result && result.event === "success") {
                console.log("Done! Here is the image info: ", result.info);

                saveUploadToDB(result.info);
            }
        }
    );
})

const toast = useToast();


const uploading = ref(false);
const start = () => {
    uploading.value = true;
    NProgress.start()
}

const done = () => {
    uploading.value = false;
    NProgress.done();
}

const uploadUrl = computed(() => {
    return `/.netlify/functions/upload-db/`;
});

const onSelectFiles = () => {
    myWidget.value.open();
}

const saveUploadToDB = async (data) => {

    start();

    const response = await fetch(uploadUrl.value, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        onprogress: onUploadProgress
    });



    if (!response.ok) {
        const error = await response.text();
        console.error("Upload error:", error);
        return onUploadError(error);
    }

    const result = await response.json();

    if (result?.data?.length > 0) {
        for (let i = 0; i < result.data.length; i++) {
            await addFileToSession(result.data[i]);
        }
    }

    return onUploadComplete(result);
}

const addFileToSession = async (data) => {

    if (typeof localStorage === 'undefined') return;

    // Get the existing JSON array from Local Storage or create an empty one if it doesn't exist
    const uploadStore = JSON.parse(localStorage.getItem('wedding-photo-app')) || [];

    // Push the new item to the array
    uploadStore.push(data);

    // Store the updated array back in Local Storage
    localStorage.setItem('wedding-photo-app', JSON.stringify(uploadStore));

}

const onUploadComplete = (event) => {
    console.log("Upload Complete", event);
    toast.add({ severity: "success", summary: "Success", detail: "File Uploaded", life: 3000 });

    done();
};
const onUploadError = (event) => {
    console.log("Upload Failed", event);
    toast.add({ severity: "error", summary: "Failed", detail: "Error Uploading", life: 3000 });

    done();
};

const onUploadProgress = (event) => {
    console.log("Upload Progress", event);
    NProgress.set(event.progress / 100);
};
</script>